import * as React from "react";

import {staticUrl} from "@repo/urls";

const SHAPE_1_CLIP =
    "M380.139 303.105C404.427 294.932 434.28 219.128 451.508 173.613C453.323 168.817 451.2 163.433 446.609 161.15L237.386 57.1088C236.45 56.6431 235.447 56.3277 234.413 56.1725C217.615 53.6513 172.874 46.7357 115.217 37.2599C40.786 25.0272 46.0614 150.875 43.958 176.436C41.8547 201.997 99.4417 228.965 184.083 274.034C268.725 319.102 354.277 311.808 380.139 303.105Z";
const SHAPE_2_CLIP =
    "M737.383 182.064L506.853 95.8527C502.831 94.3486 498.298 95.585 495.597 98.9229L392.553 226.255C391.166 227.969 390.363 230.085 390.428 232.289C391.006 251.98 400.014 293.233 433.279 325.224C477.424 367.68 553.412 362.699 592.966 350.229C622.509 340.915 699.705 250.41 741.721 197.495C745.912 192.217 743.695 184.425 737.383 182.064Z";

const Shape1 = () => (
    <React.Fragment>
        <mask
            id="last_chance_mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="7"
            y="0"
            width="457"
            height="353"
        >
            <path d={SHAPE_1_CLIP} fill="#FFF" />
        </mask>
        <g mask="url(#last_chance_mask0)">
            <image
                href={staticUrl("/images/lohp/last_chance_pattern0.jpg")}
                xlinkHref={staticUrl("/images/lohp/last_chance_pattern0.jpg")}
                height="352.5"
                width="482.5"
                id="last_chance_image0"
                x="-6"
            />
        </g>
    </React.Fragment>
);

const Shape2 = () => (
    <React.Fragment>
        <mask
            id="last_chance_mask1"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="352"
            y="20"
            width="402"
            height="404"
        >
            <path d={SHAPE_2_CLIP} fill="#FFF" />
        </mask>
        <g mask="url(#last_chance_mask1)">
            <image
                id="last_chance_image1"
                width="429.5"
                height="406.5"
                x="340"
                y="16.4736"
                href={staticUrl("/images/lohp/last_chance_pattern1.jpg")}
                xlinkHref={staticUrl("/images/lohp/last_chance_pattern1.jpg")}
            />
        </g>
    </React.Fragment>
);

const Dots = () => (
    <React.Fragment>
        <g style={{mixBlendMode: "multiply"}}>
            <image
                id="last_chance_image2"
                width="219"
                height="218"
                x="423"
                y="220"
                href={staticUrl("/images/lohp/last_chance_dots.png")}
                xlinkHref={staticUrl("/images/lohp/last_chance_dots.png")}
            />
        </g>
    </React.Fragment>
);

export const LastChanceCollageHeight = 438;

const LastChanceCollage = (): React.ReactElement<
    React.ComponentProps<"svg">
> => (
    <svg
        width={769}
        height={LastChanceCollageHeight}
        viewBox={`0 0 769 ${LastChanceCollageHeight}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <Shape1 />
        <Shape2 />
        <Dots />
    </svg>
);

export default LastChanceCollage;
